import { fromCanonicalMeasurement, isMeasurementUnit, roundMeasurement } from "@/features/inputs/measurement";
import { NumberEntryValue } from "./NumberEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface MeasurementEntryValueProps extends Omit<BaseEntryValueProps, "value"> {
    value: number | null;
    unit?: string | null;
}

export function MeasurementEntryValue({
    value,
    unit,
    inputLabel,
    size,
    className,
    ...props
}: MeasurementEntryValueProps) {
    const selectedUnit = isMeasurementUnit(unit) ? unit : undefined;
    const displayValue =
        value != null && selectedUnit ? roundMeasurement(fromCanonicalMeasurement(value, selectedUnit), 2) : value;

    return (
        <NumberEntryValue
            value={displayValue}
            unit={selectedUnit}
            inputLabel={inputLabel}
            size={size}
            className={className}
            {...props}
        />
    );
}
